module.exports = __webpack_public_path__ + "0f1d0f8ee8d9e5582c2641f9d393e399.svg";